<template>
    <div class="inner-container">
        <div class="section-title program"><span>Стратегическое планирование</span></div>
        <div class="section-subtitle"><i class="icon icon-grid"></i><span>Мониторинг СНП</span></div>
        <b-tabs class="w-100" v-model="tab">
            <b-tab title="Паспорт СНП">
                <template v-if="me && me.hasOwnProperty('katoCodes')">
                    <passport-snp
                        :me="me"
                        :reportTypes="reportTypes"
                        :regions="regions"
                        :moveTabs="moveTabs"
                        :passportFilter="passportFilter"
                        @passport="updateFromPassport"
                    />
                </template>
            </b-tab>
            <b-tab title="Согласование">
                <template v-if="me && me.hasOwnProperty('initialSnp') && me.hasOwnProperty('katoCodes')">
                    <reconciliation
                        :reportTypes="[...reportTypes, ...registryTypes]"
                        :regions="regions"
                        :me="me"
                        @go-to-passport="goToPassport"
                    />
                </template>
            </b-tab>
            <b-tab title="Формы Мониторинга">
                <div class="actions-tab in-tab snp-actions">
                    <b-dropdown variant="link" class="info" right toggle-class="text-decoration-none" no-caret>
                        <template #button-content>
                            <div class="btn-download">
                                <div>
                                        <span class="left">
                                            <i class="icon icon-info"></i>
                                        </span>
                                    <i class="icon icon-keyboard"></i>
                                </div>
                            </div>
                        </template>
                        <b-dropdown-text>
                            <div
                                class="info-button"
                                @click="downloadStaticFile(2)"
                            >
                                <span>
                                    Режим «Мониторинг СНП»
                                <i class="icon icon-folder"></i>
                                </span>
                            </div>
                            <div class="info-title">
                                <span>Мониторинг СНП</span>
                            </div>
                            <div class="info-text">
                                <p>Данный модуль предназначен для сбора и анализа данных по формам мониторинга СНП по
                                    приказу Первого заместителя Премьер-Министра Республики Казахстан - Министра
                                    регионального развития Республики Казахстан от 24 сентября 2013 года № 239/ОД. .</p>
                                <div class="info-subtitle">
                                    <span>Формы мониторинга</span>
                                </div>
                                <p>Раздел предназначен для выгрузки исторических и текущих форм мониторинга.</p>
                            </div>
                        </b-dropdown-text>
                    </b-dropdown>
                </div>
                <monitoring-form :reportTypes="reportTypes" :regions="regions"/>
            </b-tab>
            <b-tab title="Реестр">
                <template v-if="me && me.hasOwnProperty('initialSnp') && me.hasOwnProperty('katoCodes')">
                    <registry
                        :me="me"
                        :regions="regions"
                        :registryArr="registryTypes"
                        :yearsArr="years"
                        :fromPassport="fromPassport"
                    />
                </template>
            </b-tab>
            <b-tab title="Конструктор">
                <constructor :me="me" :regionArr="regions" :yearsArr="years"/>
            </b-tab>
            <b-tab title="Анализ Формы">
                <form-analysis :years="years"/>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator';
import PassportSNP from '@/modules/monitoring-snp-new/PassportSNP.vue';
import MonitoringForm from '@/modules/monitoring-snp-new/MonitoringForm.vue';
import FormAnalysis from '@/modules/monitoring-snp-new/FormAnalysis.vue';
import Constructor from '@/modules/monitoring-snp-new/Constructor.vue';
import Reconciliation from '@/modules/monitoring-snp-new/Reconciliation.vue';
import Registry from '@/modules/monitoring-snp-new/Registry.vue';
import { MonitoringSnpApi } from '@/modules/monitoring-snp-new/api/MonitoringSnpApi';
import { Ax } from '@/utils';

@Component({
    components: {
        'passport-snp': PassportSNP,
        'monitoring-form': MonitoringForm,
        'form-analysis': FormAnalysis,
        'constructor': Constructor,
        'reconciliation': Reconciliation,
        'registry': Registry
    }
})
export default class MonitoringSnp extends Vue {
    reportTypes = [];
    analyzeTypes = [];
    infoTypes = [];
    registryTypes = [];
    regions = [];
    years = [];
    me = {};
    tab = 0;
    fromPassport = '';
    passportFilter = null;

    mounted() {
        this.getMe();
        this.loadTypes();
        this.loadRegions();
        this.listOfYears();
        // this.getRegistryTypes();
    }

    updateFromPassport(fromPassport) {
        this.fromPassport = fromPassport;
    }

    goToPassport(passportFilter) {
        this.tab = 0;
        this.passportFilter = passportFilter;
    }

    moveTabs(index) {
        this.tab = index;
    }

    getMe() {
        MonitoringSnpApi
            .get('/snp/api/v1/me')
            .then(res => {
                // /snp/api/v1/me отдаёт ответ в конверте { success, data };
                // старый формат (объект пользователя в корне) тоже поддерживаем
                const body = res.data;
                const user = body && Object.prototype.hasOwnProperty.call(body, 'data')
                    ? body.data
                    : body;

                if (!user || !user.katoCodes || !user.katoCodes.length) {
                    console.warn('/snp/api/v1/me: пользователь без katoCodes', body);
                    this.me = user || {};
                    return;
                }

                const code = String(user.katoCodes[0]);
                // списочного эндпоинта reconciliations/ в новом контроллере нет:
                // коды региона/района выводим из структуры кода КАТО (9 цифр),
                // название СНП подтягиваем из справочника адресов
                // initialSnp кладём до присвоения this.me, чтобы ключ был реактивным
                this.me = {
                    ...user,
                    katoCodes: user.katoCodes.map(item => String(item)),
                    initialSnp: {
                        katoCode: code,
                        regionKatoCode: code.substr(0, 4) + '00000',
                        districtKatoCode: code.substr(0, 6) + '000'
                    }
                };
                MonitoringSnpApi
                    .get('/snp/api/v1/admin/address', { code })
                    .then(res => {
                        const address = res.data && Object.prototype.hasOwnProperty.call(res.data, 'data')
                            ? res.data.data
                            : res.data;
                        this.me.initialSnp = {
                            ...this.me.initialSnp,
                            nameRu: address?.snp,
                            snpNameRu: address?.snp
                        };
                    })
                    .catch(() => {
                    });
            })
            .catch(err => {
                console.error('/snp/api/v1/me', err);
            });
    }

    loadTypes() {
        MonitoringSnpApi
            .get('/snp/api/v1/form/metadata')
            .then(res => {
                this.reportTypes = res.data.data.REPORT.map((item) => ({
                        ...item,
                        name: item.name[`${this.$i18n.locale}`],
                    }));
                this.analyzeTypes = res.data.data.ANALYZE.map((item) => ({
                        ...item,
                        name: item.name[`${this.$i18n.locale}`],
                    }));
                this.infoTypes = res.data.data.INFO.map((item) => ({
                        ...item,
                        name: item.name[`${this.$i18n.locale}`],
                    }));
                this.registryTypes = res.data.data.REGISTRY.map((item) => ({
                        ...item,
                        name: item.name[`${this.$i18n.locale}`],
                    }));
            })
            .catch(() => {
            });
    }

    loadRegions() {
        // /snp/api/v1/me/cato отдаёт только доступные пользователю территории в конверте
        // { success, data }; у областного пользователя первой идёт сама область —
        // она и есть пункт «Все» (код области сохраняется), у районного её нет
        MonitoringSnpApi
            .get('/snp/api/v1/me/cato')
            .then(res => {
                const list = res.data?.data || [];
                this.regions = list.map((item, index) =>
                    index === 0 && String(item.code).endsWith('0000000')
                        ? { ...item, nameRu: 'Все' }
                        : item);
            })
            .catch(err => {
                console.error('/snp/api/v1/me/cato', err);
            });
    }

    listOfYears() {
        MonitoringSnpApi
            .get('/snp/api/v1/admin/years')
            .then(res => this.years = res.data)
            .catch(() => null);
    }

    // getRegistryTypes() {
    //     MonitoringSnpApi.get(`/snp/api/v1/registry/types`)
    //         .then(res => {
    //             this.registryArr = res.data;
    //         })
    //         .catch(err => {
    //             console.log('err', err)
    //         });
    // }

    downloadStaticFile(id) {
        const url = `/snp/api/v1/report/file/infoTemplate/${id}`;
        const name = +id === 1 ? "СВОД 2022-I полугодие.xlsx" : "Режим Мониторинг СНП.pdf";
        Ax(
            {
                url,
                method: "GET",
                data: null,
                responseType: "blob",
                headers: {
                    Authorization: `Bearer ${this.$store.getters.token}`,
                },
            },
                (data) => {
                const url = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", name);
                document.body.appendChild(link);
                link.click();
                },
                (error) => {
                console.log("err", error);
            }
        );
    }
}
</script>

<style>
.info-title {
    padding-left: 1em;
    font-weight: 700;
    padding-top: 1em;
}

.info-subtitle {
    font-weight: 600;
    margin-bottom: .8em;
}
</style>
